import {
  AgenciesWithFilmmakers,
  mapJsonToAgenciesWithFilmmakers,
} from "component-library";
import { getUserAttribute, UserAttributes } from "shared-auth";

export const getAgenciesWithFilmmakersFromJWT = () => {
  const agenciesWithFilmmakers: AgenciesWithFilmmakers[] =
    mapJsonToAgenciesWithFilmmakers(
      getUserAttribute(UserAttributes.Agencies)
    ) ?? [];

  return {
    agenciesWithFilmmakers,
  };
};
